<div class="my-5">
  <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [totalRecords]="totalRecords" [loading]="loading"></sm-data-table-builder>
  <sm-dialog #delete [dialog]="deleteDialog"></sm-dialog>
  <sm-dialog #addDialog [dialog]="addSeuilDialog"></sm-dialog>
  <sm-dialog #updateDialog [dialog]="updateSeuilDialog"></sm-dialog>
</div>
